/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ResponseWithErrorGeneric } from '../shared/response-with-error-generic';
import { GetDeclarationsResponseJson } from './get-declarations-response-json';
import { GetDeclarationsResult } from '../results/get-declarations-result.enum';
import { IResponseWithErrorGeneric } from '../shared/iresponse-with-error-generic.interface';
import { DeclarationDto } from '../models/declaration-dto';
import { DeclarationTypeDto } from '../models/declaration-type-dto';

//<custom-head>
import { HttpResponse } from '@angular/common/http';
//</custom-head>

export class GetDeclarationsResponse extends ResponseWithErrorGeneric<GetDeclarationsResponseJson, GetDeclarationsResult> implements IResponseWithErrorGeneric<GetDeclarationsResult> {
  public declarations: DeclarationDto[];
  public declarationTypes: DeclarationTypeDto[];

  //<custom-body>
  constructor(response: HttpResponse<GetDeclarationsResponse>) {
    super(response, GetDeclarationsResult.Error);
    if (this.result !== GetDeclarationsResult.Success) {
      return;
    }

    this.declarations = this.body.declarations ? this.body.declarations : [];
    this.declarationTypes = this.body.declarationTypes ? this.body.declarationTypes : [];
  }
  //</custom-body>
}
